<style lang="scss" scoped>
.upload-cropper {
  // border-radius: 4px;
  // border: 1px dashed #d5d5d5;
  // box-sizing: border-box;
  // padding: 10px;
  width: 100%;
  :deep .el-upload-dragger{
    height: 208px;
  }
  .uploaded{
    opacity: 0;
    height: 0;
    overflow: hidden;
  }
  .controls {
    // display: flex;
    // align-items: center;
    margin-bottom: 10px;
    .btns{
      margin-top: 8px;
    }
    .el-upload {
      margin-right: 10px;
    }
    .el-button {
      margin-right: 10px;
      margin-left: 0;
    }
  }
  .el-icon-upload{
    margin-top: 50px;
  }
  .upload-tip {
    font-size: 12px;
    color: #595959;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .cropper-box {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;
    .cropper-outer {
      width: 100%;
      max-width: 600px;
      height: 300px;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .show-preview {
      width: 100%;
      max-width: 600px;
      height: 300px;
      box-sizing: border-box;
      border: 1px dashed #d5d5d5;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      .preview-box {
        width: 100% !important;
        height: 100% !important;
        display: flex;
        align-items: center;
        justify-self: center;
        img{
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          margin: auto;
        }
      }
    }
  }
}
:deep .el-upload-list--picture .el-upload-list__item{
  // height: 208px;
  border: 1px dashed #d5d5d5;
  border-radius: 4px;
  // .el-upload-list__item-name{
  //   display: none !important;
  // }
  .el-upload-list__item-thumbnail{
    width: auto;
    height: 100%;
    object-fit: contain;
  }

}
</style>
<template>
  <section class="upload-cropper">
    <div class="controls">
      <el-upload
        class="upload-demo"
        :class="{'uploaded': option.img}"
        list-type="picture"
        :action="uploadUrl"
        :file-list="fileList"
        :show-file-list="true"
        :auto-upload="false"
        :on-change="handleChange"
        :accept="fileAccept"
        :drag="true"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="btns">
        <el-button
          size="mini"
          type="primary"
          plain
          v-if="option.img && !cropperSave"
          @click="uploadImg"
          >保存</el-button>
        <el-button
          size="mini"
          type="primary"
          plain
          v-if="option.img && cropperSave"
          @click="resetCropper"
          >重新裁剪</el-button>
        <el-button
          size="mini"
          type="warning"
          plain
          v-if="option.img || cropperSave"
          @click="clearImg"
          >清除</el-button>
      </div>
    </div>
    <div class="cropper-box" v-if="option.img">
      <div class="cropper-outer" v-if="!cropperSave">
        <vueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :info="option.info"
          :canScale="option.canScale"
          :autoCrop="option.autoCrop"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :full="option.full"
          :fixedBox="option.fixedBox"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :centerBox="option.centerBox"
          :height="option.height"
          :infoTrue="option.infoTrue"
          :maxImgSize="option.maxImgSize"
          :enlarge="option.enlarge"
          :mode="option.mode"
          @realTime="realTime"
        />
      </div>
      <div v-if="preview || cropperSave" class="show-preview">
        <div class="preview-box" :style="previews.div" style="overflow: hidden">
          <img :src="previews.url" :style="previews.img" />
        </div>
      </div>
    </div>
    <div class="upload-tip">
      只能上传{{
        (upOption.fileType && upOption.fileType.join(",")) || "jpg/png"
      }}文件，且不超过{{ upOption.fileSize }}MB
    </div>
  </section>
</template>

<script>
import { getGroupData } from "@api/DataGroup";
import { UPLOAD_IMG_URL } from "@config";
import axios from "axios";

const OSS = require("ali-oss");
import { getaliyunoss } from "@api/common";
import { addAttachment } from "@api/Attachment";

export default {
  name: "TryUploadCropper",
  props: {
    // 值
    value: [String, Object, Array],
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg", "gif"],
    },
    // 裁剪组件参数
    cropperOption: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 是否使用Oss直传
    oss: {
      type: Boolean,
      default: false,
    },
    // 是否开启裁剪预览
    preview: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value: {
      handler: function (val) {
        if (val != "" && val != undefined) {
          let imgs = JSON.parse(val);
          this.fileList = imgs.map((a) => {
            return {
              uid: a.att_id,
              name: a.att_title,
              url: a.att_oss || a.att_url,
            };
          });

          this.ossUploadData = imgs.map((a) => {
            return {
              att_id: a.att_id,
              att_title: a.att_title,
              att_url: a.att_url,
              att_oss: a.att_oss,
            };
          });
          // this.cropperSave = true;
          // this.option.img = imgs[0].att_oss || imgs[0].att_url;
          if (imgs[0].att_preview) this.previews = imgs[0].att_preview;
        } else {
          // this.fileList = this.fileList.length ? this.fileList : [];
          this.fileList = [];
          this.previews = {};
          this.cropperSave = false;
          this.option.img = "";
        }
      },
      immediate: true,
      deep: true,
    },
    cropperOption: {
      handler: function (val) {
        this.option = { ...val };
        if (val.img) this.cropperSave = true;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.upOption.fileType || this.upOption.fileSize);
    },
    fileTypeName() {
      let typeName = "";
      this.upOption.fileType.forEach((item) => {
        typeName += `${item}，`;
      });
      return typeName;
    },
    fileAccept() {
      let fileAccept = "";
      this.upOption.fileType.forEach((element) => {
        fileAccept += `.${element},`;
      });
      return fileAccept;
    },
  },
  data() {
    return {
      uploadUrl: UPLOAD_IMG_URL, // 上传的图片服务器地址
      paramsData: {
        accessToken: sessionStorage.getItem("token"),
        charset: "utf-8",
      }, // 上传携带的参数，看需求要不要
      fileList: [],
      upOption: {
        fileSize: this.fileSize,
        fileType: this.fileType,
        fileLimit: this.fileLimit,
      },
      previews: {}, // 裁剪预览
      option: {}, // 裁剪参数
      cropperSave: false, // 截图数据是否已保存
    };
  },
  created() {
    this.initData();
  },
  methods: {
    /**
     * @description: 初始化数据
     * @return {void}
     */
    async initData() {
      let { data: resImg } = await getGroupData("IMAGECONFIG");
      this.upOption = { ...resImg, fileLimit: 1 };
    },
    /**
     * @description 文件选取
     * @param {object} file 文件对象
     * @param {array} fileList 文件列表
     * @returns {void}
     */
    handleChange(file, fileList) {
      this.cropperSave = false;
      this.option.img = file.url;
      this.fileList = [...fileList];
    },
    /**
     * @description: 裁剪预览
     * @param {object} data 裁剪后的图片数据
     * @returns {void}
     */
    realTime(data) {
      this.previews = data;
    },
    /**
     * @description: 校检文件类型和大小
     * @param {blob} data 截图的blob数据
     * @return: boolean
     */
    verifyFile(data) {
      // 校检文件类型
      let file_type = data.type.split("/")[1];
      const isTypeOk = this.upOption.fileType.some((type) => {
        if (file_type.indexOf(type) > -1) return true;
        return false;
      });
      if (!isTypeOk) {
        this.$message({
          message: `文件格式不正确, 请上传${this.upOption.fileType.join("/")}格式文件!`,
          type: "error",
        });
        return false;
      }
      // 校检文件大小
      const isLt = data.size / 1024 / 1024 < this.upOption.fileSize;
      if (!isLt) {
        this.$message({
          message: `上传文件大小不能超过 ${this.upOption.fileSize} MB!`,
          type: "error",
        });
        return false;
      }
      return true;
    },
    /**
     * @description: 普通上传文件
     * @param {blob} data 截图的blob数据
     * @returns {void}
     */
    defaultUpload(data) {
      let formData = new FormData();
      this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading", 
      })
      formData.append("file", data, this.fileList[0].name);
      axios({
        url: UPLOAD_IMG_URL,
        method: "post",
        data: formData,
        headers: {
          ...this.paramsData,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          let tempFileList = [];
          this.fileList.map((item) => {
            let previews = { ...this.previews };
            previews.img = {
              width: previews.div.width,
              height: previews.div.height,
              transform: "scale(1)translate3d(0, 0, 0px)rotateZ(0deg)",
            };
            if (res.data.status === 200) {
              tempFileList = [
                {
                  att_id: res.data.data.att_id,
                  att_title: res.data.data.original_name,
                  att_url: res.data.data.address,
                  att_preview: { ...previews, url: res.data.data.address },
                },
              ];
            } else {
              tempFileList = [
                {
                  att_id: item.uid,
                  att_title: item.name,
                  att_url: item.url,
                  att_preview: { ...previews, url: item.url },
                },
              ];
            }
          });
          const tempfileData = JSON.stringify(tempFileList);
          this.$emit("input", tempFileList.length > 0 ? tempfileData : null);
          this.cropperSave = true;
        })
        .catch(() => {
          this.$message({
            message: "上传失败, 请重试",
            type: "error",
          });
        })
        .finally(() => {
          this.$loading().close();
        });
    },
    /**
     * @description: oss上传文件
     * @param {blob} data 截图的blob数据
     * @returns {void}
     */
    async ossUpload(data) {
      let file = new File([data], this.fileList[0].name, {
        type: data.type,
      });
      Object.defineProperty(file, "uid", {
        value: this.fileList[0].uid,
        writable: true,
        enumerable: true,
      });
      const _name = `${this.getDate()}/${this.fileList[0].uid}.${
        data.type.split("/")[1]
      }`;
      this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading", 
      })
      // if (file) {
      //   await this.putTwoOss(_name, file);
      //   }

      /** 上传oss */
      this.putOss(_name, file).then(async (res) => {
        if (res) {
          this.getOssUrl(res.name).then(async (rel) => {
            console.log(rel);
            const url = new URL(rel);
            console.log(url);
            const requestUrls = url.origin + url.pathname;
            let tempItem = {
              att_title: this.fileList[0].name,
              att_url: requestUrls,
            };
            let att_data = await this.addAttachment(tempItem);
            let previews = { ...this.previews };
            previews.img = {
              width: previews.div.width,
              height: previews.div.height,
              transform: "scale(1)translate3d(0, 0, 0px)rotateZ(0deg)",
            };
            console.log(previews);
            
            let tempFileList = [
              {
                att_title: this.fileList[0].name,
                att_id: att_data.att_id,
                att_url: att_data.att_url,
                att_oss: requestUrls,
                att_preview: { ...previews, url: requestUrls },
              },
            ];
            const tempfileData = JSON.stringify(tempFileList);
            this.$emit("input", tempFileList.length > 0 ? tempfileData : null);
            this.cropperSave = true;
          });
        } else {
          return this.$message({
            message: "直传OSS失败, 请重试",
            type: "error",
          });
        }
        this.$loading().close();
      });
    },
    /**
     * @description: 上传裁剪后的图片
     * @returns {void}
     */
    uploadImg() {
      //获取截图的blob数据
      this.$refs.cropper.getCropBlob(async (data) => {
        if (this.verifyFile(data)) {
          // 使用oss直传
          if (this.oss) {
            this.ossUpload(data);
          } else {
            // 使用默认上传
            this.defaultUpload(data);
          }
        }
      });
    },
    /**
     * @description: 清除图片
     * @returns {void}
     */
    clearImg() {
      this.fileList = [];
      this.previews = {};
      this.option.img = "";
      this.cropperSave = false;
      this.$emit("input", null);
      this.$forceUpdate();
    },
    resetCropper() {
      this.option.img = this.fileList[0].url;
      this.cropperSave = false;
      this.$emit("input", null);
      this.$forceUpdate();
    },
    /**
     * @description: 获取当前年月日
     * @return: string
     */
    getDate() {
      const date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      month = month > 9 ? month : "0" + month;
      day = day < 10 ? "0" + day : day;
      var today = year + month + day;
      return today;
    },
    /**
     * @description: 提交数据到oss获取oss返回数据
     * @param {string} fileName 文件名
     * @param {file} file 文件对象
     * @return: Promise
     */
    async putOss(fileName, file) {
      try {
        let res = await getaliyunoss();
        let ossConfig = res.data;
        const client = new OSS({
          region: ossConfig.region,
          accessKeyId: ossConfig.accessKeyId,
          accessKeySecret: ossConfig.accessKeySecret,
          stsToken: ossConfig.securityToken,
          bucket: ossConfig.bucket,
        });
        // 开启加速
        client.options.endpoint={
                    "protocol": "https:",
                    "slashes": true,
                    "auth": null,
                    "host": "oss-accelerate.aliyuncs.com",
                    "port": null,
                    "hostname": "oss-accelerate.aliyuncs.com",
                    "hash": null,
                    "search": null,
                    "query": null,
                    "pathname": "/",
                    "path": "/",
                    "href": "https://oss-accelerate.aliyuncs.com/"
                };
                
        let fileurl = ossConfig.img_path + fileName;
        const headers = {
          "Content-Encoding": "utf-8",
          "Access-Control-Allow-Origin": "*",
        };
        const options = {
          headers: headers,
          // 获取分片上传进度、断点和返回值。
          progress: (p, cpt, res) => {
            console.log(p);
          },
          // 设置并发上传的分片数量。
          parallel: 10,
          // 设置分片大小。默认值为1 MB，最小值为100 KB。
          partSize: 1024 * 1024 * 2,
          // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
          // meta: { year: 2020, people: "test" },
          // mime: "text/plain",
        };
        // 分片上传
        const result = await client.multipartUpload(fileurl, file, options);
        return result;
      } catch (e) {
        console.log(e);
      }
    },

    /** 上传第二个oss */
    async putTwoOss(filename, file) {
      try {
        let res = await getaliyunoss();
        let ossConfig = res.data;
        const client = new OSS({
          region: ossConfig.region2 ? ossConfig.region2 : "",
          accessKeyId: ossConfig.accessKeyId,
          accessKeySecret: ossConfig.accessKeySecret,
          stsToken: ossConfig.securityToken,
          bucket: ossConfig.bucket2 ? ossConfig.bucket2 : "", // 第二个oss的bucket自行替换
        });
        // 开启加速
        client.options.endpoint={
                "protocol": "https:",
                "slashes": true,
                "auth": null,
                "host": ossConfig.region2+".aliyuncs.com",
                "port": null,
                "hostname": ossConfig.region2+".aliyuncs.com",
                "hash": null,
                "search": null,
                "query": null,
                "pathname": "/",
                "path": "/",
                "href": "https://oss-accelerate.aliyuncs.com/"
            };
        let fileurl = ossConfig.img_path + filename;
        const headers = {
          // 指定该Object被下载时的内容编码格式。
          "Content-Encoding": "utf-8",
          "Access-Control-Allow-Origin": "*",
        };
        const options = {
          headers: headers,
          // 获取分片上传进度、断点和返回值。
          progress: (p, cpt, res) => {
            console.log(p);
            // this.loadingText = (p * 100).toFixed(0) + "%";
          },
          // 设置并发上传的分片数量。
          parallel: 10,
          // 设置分片大小。默认值为1 MB，最小值为100 KB。
          partSize: 1024 * 1024 * 2,
          // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
          meta: { year: 2020, people: "test" },
          //mime: "text/plain",
          timeout: 600000, //设置超时时间
        };
        const result = await client.multipartUpload(fileurl, file, options);
        console.log("putTwoOss", result);
        // return true;
        return result;
      } catch (e) {
        return e;
      }
    },
    /**
     * @description: 获取oss文件的url
     * @param {string} name 文件名称
     * @return: Promise
     */
    async getOssUrl(name) {
      try {
        let res = await getaliyunoss();
        let ossConfig = res.data;
        const client = new OSS({
          region: ossConfig.region,
          accessKeyId: ossConfig.accessKeyId,
          accessKeySecret: ossConfig.accessKeySecret,
          stsToken: ossConfig.securityToken,
          bucket: ossConfig.bucket,
        });
        const result = await client.signatureUrl(name);
        return result;
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * @description: 文件添加附件库
     * @param {object} data 文件上传oss的数据信息
     * @return: Object
     */
    async addAttachment(data) {
      data.att_storage = 2;
      const { data: resdata } = await addAttachment(data);
      return resdata;
    },
  },
};
</script>
